
	import Vue from "vue";

	export default Vue.extend({
		name: "DatePickerBuilder",
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
			label: {
				type: String,
				default: "",
			},
			value: {
				type: String,
				default: "",
			},
		},
		data() {
			return {};
		},
	});
